import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { siteInfo } from "./Features/HomeApi/HomeSlice";
import { Outlet } from "react-router-dom";
import Navbar from "./views/Components/navbar/navbar";
import Footer from "./views/Containers/Footer";
import SEO from "./views/Components/Seo/Seo";







const HomeRouter = () => {
  const dispatch = useDispatch();
  const siteInfoData = useSelector((state) => state.home?.siteInfo);

  useEffect(() => {
    dispatch(siteInfo());
  }, [dispatch]);

  return (
    <>
      {siteInfoData?.seo_data?.meta_description && (
        <SEO
          description={siteInfoData.seo_data.meta_description}
          title={siteInfoData.seo_data.meta_title}
        />
      )}

      <Navbar />
      <Outlet />
      <Footer />
    </>
  );
};

export default HomeRouter;
